import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import { getPostById, getPosts } from "../../service/apiBackEnd";
import { Container, Col, Row } from 'react-bootstrap';
import styles from '../index.module.css'
import Carousel from 'react-bootstrap/Carousel';
import { ROUTES } from "../../routes";


const SinglePost = (props) => {

    const params = useParams()
    const navigate = useNavigate();
    const [post, setPost] = useState(null);
    const [allPosts, setAllPosts] = useState([]);
    useEffect(() => {
        const fetchPost = async () => {
            const data = await getPostById(params.id);       
            setPost(data);
        };
        const fetchAllPosts = async () => {
            const posts = await getPosts(); // Suponiendo que este método devuelve todos los posts
            setAllPosts(posts);
        };
        fetchPost();
        fetchAllPosts();
    }, [params.id]);

   
    const plainTextPost = post?.content?.rendered.replace(/<\/?[^>]+(>|$)/g, "");
    const featuredImage = post?._embedded?.['wp:featuredmedia']?.[0]?.source_url || '';

    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };
    const currentIndex = allPosts.findIndex(p => p.id === parseInt(params.id));

    const handleNavigation = (direction) => {
        if (currentIndex !== -1) {
            const nextIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;
            if (nextIndex >= 0 && nextIndex < allPosts.length) {
                navigate(`/noticias/${allPosts[nextIndex].id}`);
            }
        }
    };

    const extractImages = (htmlContent) => {
        const div = document.createElement('div');
        div.innerHTML = htmlContent;
        const images = [...div.querySelectorAll('img')].map(img => ({
            src: img.src,
            alt: img.alt,
        }));

        return images;
    };

    const images = extractImages(post?.content?.rendered);

    if (!post) {
        return <div style={{textAlign:"center", fontWeight:"600", color: "var(--primary-color)", fontSize: "2em"}}>Cargando...</div>;
    }

    return (
        <Container>
            <Row className='mb-5'>
                <h3 style={{marginTop: "1em"}}>{post?.title?.rendered}</h3>
                <p>Fecha: {new Date(post.date).toLocaleDateString()}</p>
                <hr></hr>
                <Col lg={12} className='mt-4'>
                    {featuredImage && <img src={featuredImage} alt={post.title.rendered} className={styles.singleMainImg} />}
                </Col>
                <Col lg={12} className='mt-4'>
                    <p>{plainTextPost}</p>
                </Col>
            </Row>
            {images.length == 0 ? "" :
                <Row className={styles.carousel}>
                    <Carousel activeIndex={index} onSelect={handleSelect} data-bs-theme="dark">
                        {images.map((image, index) => (
                            <Carousel.Item>
                                <img key={index} src={image.src} alt={image.alt || `Imagen ${index + 1}`} className={styles.singleImg} /></Carousel.Item>
                        ))}
                    </Carousel>
                </Row>}
                <button onClick={() => navigate(ROUTES.noticias.path)}
                            className={styles.btnMasNoticias}
                        >Ver todas las noticias</button>
            <hr></hr>
            <Row className={styles.navegacionPost}>
                <Col lg={6} sm={6} xs={6}>{currentIndex === 0 ? "" :
                    <li><button onClick={() => handleNavigation('previous')}>Anterior</button></li>}</Col>
                <Col lg={6} sm={6} xs={6} className={styles.btnSiguiente}>
                    {allPosts.findIndex(p => p.id === parseInt(params.id)) < allPosts.length - 1 && <li><button onClick={() => handleNavigation('next')}>Siguiente</button></li>}
                </Col>
            </Row>
        </Container >
    )
}

export default SinglePost

